"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var json_rpc_dispatcher_1 = require("@dealroadshow/json-rpc-dispatcher");
var ProtocolHelper_1 = __importDefault(require("../ProtocolHelper"));
var api_1 = require("@opentelemetry/api");
var instrumentation_1 = require("../instrumentation");
var RESPONSE_TIMEOUT = 300000; // 300 seconds
var tracer = api_1.trace.getTracer(instrumentation_1.OTEL_TRACER_NAME);
/**
 * SockJs Adapter for @dealroadshow/json-rpc-dispatcher
 */
var SockJsAdapter = /** @class */ (function () {
    function SockJsAdapter(requestUrl, sockJsConnection) {
        var _this = this;
        this.onMessage = function (message) {
            var _a;
            var response = (0, json_rpc_dispatcher_1.parse)(message);
            var socketResponseId = SockJsAdapter.getRpcObjectId(response);
            if (_this.activeRequestsResolvers.get(socketResponseId)) {
                clearTimeout(_this.responseTimeout);
                (_a = _this.activeRequestsResolvers.get(socketResponseId)) === null || _a === void 0 ? void 0 : _a(message);
                _this.activeRequestsResolvers.delete(socketResponseId);
            }
        };
        /**
         * Get sockJs connection
         *
         * @return {Connection}
         */
        this.getConnection = function () { return _this.connection; };
        if (!requestUrl) {
            throw new TypeError('requestUrl is required to perform a socket calls');
        }
        if (!sockJsConnection) {
            throw new TypeError('sockJsConnection is required to perform a socket calls');
        }
        this.requestUrl = requestUrl;
        this.connection = sockJsConnection;
        this.activeRequestsResolvers = new Map();
        this.connection.onMessage(this.onMessage);
    }
    SockJsAdapter.prototype.call = function (request) {
        var _this = this;
        return tracer.startActiveSpan((0, instrumentation_1.withPrefix)('SockJsAdapter.call'), function (span) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var _a;
                        request = _this.addRequestUrlHeader(request);
                        var socketRequestId = SockJsAdapter.getRpcObjectId(request);
                        if (socketRequestId) {
                            _this.activeRequestsResolvers.set(socketRequestId, function (message) {
                                resolve(message);
                                span.addEvent('response-received');
                                span.end();
                            });
                        }
                        api_1.propagation.inject(api_1.context.active(), (_a = request === null || request === void 0 ? void 0 : request.params) === null || _a === void 0 ? void 0 : _a.headers);
                        _this.connection.send(JSON.stringify(request));
                        if (!socketRequestId) {
                            resolve(undefined);
                            span.addEvent('notification-sent');
                            span.end();
                            return;
                        }
                        _this.responseTimeout = setTimeout(function () {
                            reject(json_rpc_dispatcher_1.JsonRpcError.internalError({ id: request.id, data: 'Request timeout' }));
                            span.addEvent('response-timeout');
                            span.end();
                        }, RESPONSE_TIMEOUT);
                    })];
            });
        }); });
    };
    SockJsAdapter.getRpcObjectId = function (rpcObject) {
        var _a;
        return Array.isArray(rpcObject)
            ? (_a = rpcObject.filter(function (el) { return !!el.id; })[0]) === null || _a === void 0 ? void 0 : _a.id
            // @ts-ignore
            : rpcObject.id;
    };
    SockJsAdapter.prototype.addRequestUrlHeader = function (request) {
        var _this = this;
        if (Array.isArray(request)) {
            return request.map(function (req) { return ProtocolHelper_1.default.bindRequestUrl(_this.requestUrl, req); });
        }
        return ProtocolHelper_1.default.bindRequestUrl(this.requestUrl, request);
    };
    return SockJsAdapter;
}());
exports.default = SockJsAdapter;
//# sourceMappingURL=SockJsAdapter.js.map